export default __webpack_public_path__ + "static/media/icons-crypto-metamask.7d147f1c.svg";